<template>
    <v-container ref="pageActions" fluid tag="section">

        <material-card icon="mdi-clipboard-text" icon-small title="Банери" color="accent" class="mb-16">
            <!--Фильтры-->
            <v-row class="mx-2 mb-2">
                <v-col cols="12" md="3">
                    <v-select return-object item-text="name" item-value="name" v-model="project" :items="projects"
                        label="Проект" clearable @change="setQueryParam()"></v-select>
                </v-col>
                <v-col cols="12" md="3">
                    <v-select return-object item-text="text" item-value="value" v-model="position" :items="positions"
                        label="Позиція" clearable @change="setQueryParam()"></v-select>
                </v-col>
                <v-col cols="12" md="3">
                    <v-select return-object item-text="text" item-value="value" v-model="actual" :items="actualBanners"
                        label="Актуальний" clearable @change="setQueryParam()"></v-select>
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Пошук" single-line
                        hide-details></v-text-field>
                </v-col>
            </v-row>

            <!--Таблица-->
            <v-data-table :headers="headers" :items="items" class="elevation-1" :search="search"
                :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50, 100, -1] }" :options="{ itemsPerPage }">
                <template v-slot:item.image="{ item }">
                    <v-img contain height="100" width="100" :src="`${imageBaseUrl}${item.image}`"></v-img>
                </template>
                <template v-slot:item.position="{ item }">
                    <div v-if="item.main_position">Стартова сторінка</div>
                    <div v-if="item.popup_position">Popup</div>
                    <div v-if="item.menu_position">Меню сайту
                        <ul v-html="item.menu_position">
                        </ul>
                    </div>
                    <div v-if="item.catalog_position">Каталог товарів
                        <ul v-html="item.catalog_position">
                        </ul>
                    </div>
                </template>
                <template v-slot:item.action="{ item }">
                    <v-btn icon :to="`/banners/${item.id}`">
                        <v-icon color="blue">mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn icon @click="deleteBanner(item)">
                        <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
            <!--Диалоговое окно для удаления-->
            <DialogConfitmDelete ref="dialogConfirmDelete" />
            <Preloader v-if="isSending" />
        </material-card>

        <v-btn v-if="isManager || isAdmin" class="add-user__button" fab dark color="primary" to="/banners/add/">
            <v-icon dark>
                mdi-plus
            </v-icon>
        </v-btn>

    </v-container>
</template>

<script>
import { HTTP } from '@/http-common';
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { IMAGE_BASE_URL } from '@/env.config';

export default {
    name: 'RegularTablesView',
    data() {
        return {
            // Текущий проект
            project: {},
            // Количество элементов на странице
            itemsPerPage: 50,
            // Количество страниц
            isSending: false,
            headers: [
                { text: 'ID', value: 'id' },
                { text: 'Назва', value: 'name' },
                { text: 'Зображення', value: 'image', },
                { text: 'Місце', value: 'position' },
                { text: 'Проект', value: 'project_name' },
                { text: 'Термін дії', value: 'active_period', },
                { text: 'Управління', value: 'action', sortable: false },
            ],
            positions: [
                { text: 'Стартова сторінка', value: 'main' },
                { text: 'Меню сайту', value: 'menu' },
                { text: 'Каталог товарів', value: 'catalog' },
                { text: 'Popup', value: 'popup' },
            ],
            items: [],
            search: '',
            position: null,
            actualBanners: [
                { value: 1, text: 'Так' },
                { value: 0, text: 'Ні' }
            ],
            actual: null,
            imageBaseUrl: `${IMAGE_BASE_URL}banners/`
        }
    },
    computed: {
        ...mapGetters(['isManager', 'isAdmin', 'projects']),
    },

    mounted() {
        this.init();
    },

    watch: {
        // '$route': {
        //     handler() {
        //         this.getActions();
        //     },
        //     deep: true,
        // }
    },

    methods: {
        ...mapMutations(['setSnackbar']),
        ...mapActions(['getProjects']),

        async init() {
            await this.getProjects();
            await this.getBannersList();

        },
        async getBannersList() {
            this.isSending = true;
            try {
                let { data } = await HTTP.post('/get-banners-list', {
                    project_id: this.project.id,
                    position: this.position ? this.position.value : null,
                    actual: this.actual !== null ? this.actual.value : null,
                });
                this.items = data.content;
            } catch (e) {
                this.setSnackbar({ color: 'error', text: e.message || e });
            } finally {
                this.isSending = false;
            }
        },
        setQueryParam() {
            this.getBannersList();
        },
        async deleteBanner(item) {
            let isConfirmDelete = await this.$refs.dialogConfirmDelete.callDialog();
            if (!isConfirmDelete) return;
            this.isSending = true;

            try {
                await HTTP.post('/delete-banner', { id: item.id });
                await this.getBannersList();
            } catch (e) {
                this.setSnackbar({ color: 'error', text: e.message || e });
            } finally {
                this.isSending = false;
            }
        },
    },
}

</script>

<style>
.add-user__button {
    position: fixed;
    bottom: 20px;
    right: 20px;
}
</style>
